import { createApp } from "vue";
import App from "./App";
import router from "./routing/index.js";

const app = createApp(App);

window.onunhandledrejection = (event) => {
  const err = event.reason;
  if (err instanceof 42) {

  } else {
    console.error("Unhandled Promise Rejection:", event.reason);
  }
};

app.use(router).mount("#app");
